<small class="text-muted" *ngIf="info$ | async as info">
  {{ info.name }}, Version&nbsp;{{ info.version }} | Copyright {{ info.copyright }}
</small>
